let i = 0;
let j = 0;
jQuery(document).ready(function ($) {
  $("#girlCheck,#boyCheck,#arabicCheck,#foreignCheck").change(function () {
    i++;
    $("#baby-names-loading-overlay").css("display", "flex");
    var str = "";

    var starts_with = $(".letter.active").text();
    if (starts_with.length > 0) {
      str += "&starts_with=" + starts_with;
    }

    var search_tags1 = [];

    if ($("#girlCheck").is(":checked")) {
      search_tags1.push("أسماء بنات");
    }
    if ($("#boyCheck").is(":checked")) {
      search_tags1.push("أسماء أولاد");
    }
    if (search_tags1.length > 0) {
      str += "&tag_name1=" + search_tags1.toString();
    }

    var search_tags2 = [];
    if ($("#arabicCheck").is(":checked")) {
      search_tags2.push("اسماء عربية");
    }
    if ($("#foreignCheck").is(":checked")) {
      search_tags2.push("اسماء اجنبية");
    }
    if (search_tags2.length > 0) {
      str += "&tag_name2=" + search_tags2.toString();
    }

    str += "&baby_names=1&pageNumber=1&action=more_post_ajax";

    $.ajax({
      type: "POST",
      dataType: "html",
      url: loadmore_params.ajaxurl,
      data: str,
      success: function (data) {
        var $data = $(data);
        if ($data.length) {
          $(".search_grid").html($data);
          j++;
          if (i == j) {
            $("#baby-names-loading-overlay").css("display", "none");
          }
        }
      },
      error: function (jqXHR, textStatus, errorThrown) {
        $("#baby-names-loading-overlay").css("display", "none");
      },
    });
    return false;
  });
});
